export enum ReasonType {
  type = "1",
  size = "2",
}
export interface IUploadErr {
  name: string;
  reason: ReasonType;
}
export interface TempFile {
  id: number;
  name: string;
  url: string;
  isImage: boolean;
  thumbnail?: string;
}

export const supportedFileExts = [
  ".jpeg",
  ".bmp",
  ".png",
  ".jpg",
  ".gif",
  ".svg",
  ".avif",
  ".webm",
  ".mp4",
  ".pdf",
  ".mov",
  ".csv",
  ".xlsx",
  ".xls",
  ".m4a",
  ".mp3",
  ".wav",
  ".wma",
  ".aac",
];

export const fileNameAndExt = (fullName: string) => {
  const file = fullName.split("/").pop();
  return {
    name: file?.substring(0, file.lastIndexOf(".")),
    ext: "." + file?.substring(file.lastIndexOf(".") + 1, file.length),
  };
};

export const fileAccepted = (file: File) => {
  const ext = file?.name.split(".").pop()?.toLowerCase() ?? "";
  if (!supportedFileExts?.includes(ext)) return false;
  if (file.size / 1024 > 2e3) return false;
  return true;
};

export const fileNotAccepted = (file: File) => {
  const ext = fileNameAndExt(file.name).ext.toLowerCase();
  let reason: ReasonType | null = null;
  if (!supportedFileExts?.includes(ext)) reason = ReasonType.type;
  else if (file.size / 1024 > 2e3) reason = ReasonType.size;
  return reason ? { name: file.name, reason: reason } : null;
};

export const deepCopyFunction = (inObject: any) => {
  let outObject: any, value, key;
  if (typeof inObject !== "object" || inObject === null) {
    return inObject; // Return the value if inObject is not an object
  }
  // Create an array or object to hold the values
  outObject = Array.isArray(inObject) ? [] : {};

  for (key in inObject) {
    value = inObject[key];

    // Recursively (deep) copy for nested objects, including arrays
    outObject[key] = deepCopyFunction(value);
  }

  return outObject;
};
